module.exports = __webpack_public_path__ + "img/img-border.ff29ddfc.png";